import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { Modal } from '@/components/Modal'
import {
  useSendStore,
  getCurrencyColors,
  CurrencyData,
} from '@/store/useSendStore'

// Используем те же компоненты что и в add-money
import { CurrencyItem } from '@/features/add-money/select-currency/components/CurrencyItem'
import type { CurrencyItemProps } from '@/features/add-money/select-currency/components/CurrencyItem'

interface SendCurrencyBottomSheetProps {
  isOpen: boolean
  onClose: () => void
}

// Список доступных валют для отправки (только 4 валюты: Tether, Bitcoin, Ethereum, Gold)
const sendCurrencies: Omit<CurrencyItemProps, 'onPress'>[] = [
  {
    id: '1',
    name: 'Tether USD',
    code: 'USDT',
    displayCurrencyCode: 'USDT',
    icon: 'https://storage.googleapis.com/kem-catalog-stage/currencies/usdt.png',
    avatarBGRefColor: '#33CC67',
  },
  {
    id: '2',
    name: 'Bitcoin',
    code: 'BTC',
    displayCurrencyCode: 'BTC',
    icon: 'https://storage.googleapis.com/kem-catalog-stage/currencies/btc.png',
    avatarBGRefColor: '#F7931A',
  },
  {
    id: '3',
    name: 'Ethereum',
    code: 'ETH',
    displayCurrencyCode: 'ETH',
    icon: 'https://storage.googleapis.com/kem-catalog-stage/currencies/eth.png',
    avatarBGRefColor: '#7059FF',
  },
  {
    id: '4',
    name: 'Solana',
    code: 'SOL',
    displayCurrencyCode: 'SOL',
    icon: 'https://assets.coingecko.com/coins/images/4128/large/solana.png',
    avatarBGRefColor: '#000000',
  },
  {
    id: '5',
    name: 'Tether Gold',
    code: 'XAUT',
    displayCurrencyCode: 'XAUT',
    icon: 'https://storage.googleapis.com/kem-catalog-stage/currencies/gold.png',
    avatarBGRefColor: ['#FCFBE7', '#FFD475', '#DD8536'],
  },
  // {
  //   id: '6',
  //   name: 'Kuwaiti Dinar',
  //   code: 'KWDK',
  //   displayCurrencyCode: 'KWD',
  //   icon: '',
  //   avatarBGRefColor: '#0051A0',
  // },
  // {
  //   id: '7',
  //   name: 'UAE Dirham',
  //   code: 'AEDK',
  //   displayCurrencyCode: 'AED',
  //   icon: '',
  //   avatarBGRefColor: '#000000',
  // },
  // {
  //   id: '8',
  //   name: 'Saudi Riyal',
  //   code: 'SARK',
  //   displayCurrencyCode: 'SAR',
  //   icon: '',
  //   avatarBGRefColor: '#005430',
  // },
]

export const SendCurrencyBottomSheet: React.FC<
  SendCurrencyBottomSheetProps
> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  const setSelectedCurrency = useSendStore((state) => state.setSelectedCurrency)
  const setCryptoAmount = useSendStore((state) => state.setCryptoAmount)
  const setFiatAmount = useSendStore((state) => state.setFiatAmount)
  const setIsFiatMode = useSendStore((state) => state.setIsFiatMode)

  const handleCurrencySelect = (
    currency: Omit<CurrencyItemProps, 'onPress'>,
  ) => {
    // Создаем объект CurrencyData с цветами для выбранной валюты
    const currencyData: CurrencyData = {
      code: currency.code,
      name: currency.name,
      icon: currency.icon,
      ...getCurrencyColors(currency.code), // Получаем цвета для фона и градиентов
    }

    // Обновляем выбранную валюту в store
    setSelectedCurrency(currencyData)

    // Сбрасываем суммы и переключаемся в фиатный режим (как в React Native)
    setCryptoAmount({
      amount: '0',
      code: currency.code,
    })
    setFiatAmount({
      amount: '0',
      code: 'USD',
    })
    setIsFiatMode(true)

    // Закрываем модал
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('screens:sendRequest.selectCurrency', 'Select Currency')}
      showHandle={true}
    >
      <BaseView
        style={{
          gap: 12,
          paddingBottom: 20,
        }}
      >
        {sendCurrencies.map((currency) => (
          <CurrencyItem
            key={currency.id}
            {...currency}
            onPress={() => handleCurrencySelect(currency)}
          />
        ))}
      </BaseView>
    </Modal>
  )
}
